export const ROUTES = {
  HOME: '/',
  PRICING: '/price',
  FREE_COURSES: '/courses/free',
  NEW_COURSES: '/courses/new',
  COURSES_BROWSE: '/courses/browse',
  COURSE_DETAIL: (courseId) => `/courses/${courseId}`,
  COURSE_PLAYLIST: (courseId) => `/courses/${courseId}/play`,
  TEACHER_DETAIL: (teacherId) => `/teachers/${teacherId}`,
  PROFILE: '/profile',
  PROFILE_PLAN: '/profile/plan',
  PROFILE_PROGRESS: '/profile/progress',
  PROFILE_FAVORITES: '/profile/favorites',
  PROFILE_HELP: '/profile/help',
  CONTACT: '/contact',
  ABOUT_US: '/about-us',
  POLICY: (type) => `/policies/${type}`,
  PAYMENT_SUCCESS: '/payment/success',
  PAYMENT_FAILED: '/payment/failed',
  PAYMENT_CALLBACK: '/payment/callback',
  PAYMENT_PENDING: '/payment/pending',
};
